//NOTE for analytics to match the page using the iframe for this app, make this match
export const BASE_PATH = "/resources/";

export const ROUTE_PATHS = {
  map: "map",
  table: "table",
  sources: "sources",
};

export const ROUTE_NAMES = {
  map: "Map",
  table: "Table",
  sources: "sources",
};
